import { render, staticRenderFns } from "./TheChatMessagesList.vue?vue&type=template&id=1bdfe6f9"
import script from "./TheChatMessagesList.vue?vue&type=script&lang=js"
export * from "./TheChatMessagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports